'use client';

import React, { useState, useEffect, useRef } from 'react';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
//import BlockViewer from '../BlockViewer';
import DataTableGenerica from './DataTableGenerica/DataTableGenerica';

import { PlantillaService } from '../service/PlantillaService';
import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';
import ContentCardOrganizator from '../templates/ContentCardOrganizator';


import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';

import '../App.css';

const BlocksInscripcion = (props) => {

    console.log("BlocksInscripcion, ");

    const authController = new AuthController();
    const [authStorage, setAuthStorage] = useState(undefined);

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;



    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;

    const [queryParams, setQueryParams] = useState(undefined);
    const [tipoRecibo, setTipoRecibo] = useState(undefined);

    const urlFullLogoLoginDefault = "assets/layout/images/logo-login.png";

    let urlFullLogoLogin = urlLogoLogin ? process.env.NEXT_PUBLIC_URL_API + urlLogoLogin : urlFullLogoLoginDefault;

    //const { user: ContextState, configSubdomain, login } = useContext(AuthProvider);
    //const {isLoginPending,isLoggedIn,loginError, subdomain, userName, idSuscripcion, idEmpresa, idioma } = ContextState;

    //const authService = new AuthService();
    const plantillaService = new PlantillaService();

    const codMenu = "LOGIN";

    const [etiquetasMenu, setEtiquetasMenu] = useState([]);
    const [intentoErrado, setIntentoErrado] = useState(0);
    const [vecesBotonPresionado, setVecesBotonPresionado] = useState(0);

    //const selectedTipoGenericaRef = { tg: "BAS_TERCERO", version: 0, filtroUts: { 'documentoTercero': '__' } };

    const [checked, setChecked] = useState(false);
    const [form, setForm] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: 'visit',
        password: ''
    });

    const [dataConsulta, setDataConsulta] = useState({
        NUM_IDENTIFICACION: '',
    });

    const getSelectedTipoGenericaByQueryParamTipoRecibo = (tipoRecibo) => {

        let res = undefined;

        if (tipoRecibo == "I") {
            res = {
                tg: "ALDEA_VSTART_FORMULARIO_RECIBO_PAGO", tipoOrganizacionContenido: "CONFIG_SEVERAL_CARD", cantidadCard: 2,
                version: 0, ctiTextoFiltroUts: "", filtroUts: { 'NUM_IDENTIFICACION': '__' }
            }
        }
        else if (tipoRecibo == "M") {
            res = {
                tg: "ALDEA_VSTART_MATRICULA_RECIBO_PAGO", tipoOrganizacionContenido: "CONFIG_SEVERAL_CARD", cantidadCard: 2,
                version: 0, ctiTextoFiltroUts: "", filtroUts: { 'NUM_IDENTIFICACION': '__' }
            }
        }
        return res;
    }

    const selectedTipoGenericaRef = useRef(undefined);

    useEffect(() => {

        console.log("useEffect_BlocksGuestUserURL, ");

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;

        setAuthStorage(authStorage);
        setDataConfigSubdomain(mewdataConfigSubdomain);

        const userDetails = authStorage.GetCurrentUser();
        userName = userDetails.userName;
        idioma = userDetails.idioma;
        idEmpresa = userDetails.idEmpresa;
        sessionGUID = userDetails.sessionGUID
        documentoInvitado = userDetails.documentoInvitado

        let formDefault = {
            idSuscripcion: idSuscripcion,
            idioma: idiomaInit,
            idEmpresa: idEmpresaInit,
            subdomain: subdomain,
            userName: 'visit',
            password: ''
        };

        let response = authController.loginUser(formDefault) //loginUser action makes the request and handles all the neccessary state changes
        console.log("responseVisit, ", response);
        loadDatosBase();

        const queryParams = new URLSearchParams(window.location.search);
        setQueryParams(queryParams);
        let tipoRecibo = queryParams.get("tipoReciboPago");

        setTipoRecibo(tipoRecibo);

        selectedTipoGenericaRef.current = getSelectedTipoGenericaByQueryParamTipoRecibo(tipoRecibo)



    }, []);

    const loadDatosBase = () => {
        plantillaService.getEtiquetasMenuAuth(idEmpresaInit, idiomaInit, codMenu).then(data => {
            console.log("getEtiquetasMenuAuth, ", data);
            setEtiquetasMenu(data);
        });
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _dataConsulta = { ...dataConsulta };
        _dataConsulta[`${name}`] = val;
        setDataConsulta(_dataConsulta);
    }


    const clickBuscar = async (e) => {

        //e.preventDefault();
        try {

            if (dataConsulta.NUM_IDENTIFICACION !== "") {
                let newSelectedTipoGenericaRef = { ...selectedTipoGenericaRef.current }

                newSelectedTipoGenericaRef.version += 1;
                newSelectedTipoGenericaRef.filtroUts['NUM_IDENTIFICACION'] = dataConsulta.NUM_IDENTIFICACION;

                //console.log("newSelectedTipoGenericaRef, ", newSelectedTipoGenericaRef);

                selectedTipoGenericaRef.current = newSelectedTipoGenericaRef;
                //setSelectedTipoGenericaRef(newSelectedTipoGenericaRef);
                setIntentoErrado(prev => prev > 0 ? 0 : prev - 1);
            }
            else {
                setIntentoErrado(prev => prev < 0 ? 0 : prev + 1);
            }
        } catch (error) {
            console.log(error)
        }

        setVecesBotonPresionado(prev => prev + 1);

    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasMenu.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    const mensajeError = (_intentoErrado) => {

        if (vecesBotonPresionado > 0) {
            if (dataConsulta.NUM_IDENTIFICACION === "") {
                return (<label htmlFor="btLogin" >Debe ingresar documento de identidad.</label>);
            }
            else if (intentoErrado > 0) {

                return (<label htmlFor="btLogin" >Nombre de usuario es incorrecto</label>);
            }

        }
        else
            return (<></>);
    }



    const TablaReciboInscripcion = () => {

        return (<div className="card col-12 md:col-12 lg:col-12">
            <ContentCardOrganizator muestraCabecera={false}
                selectedTipoGenerica={selectedTipoGenericaRef.current} />
        </div>);
    }

    const TablaReciboInscripcion2 = () => {

        return (<div className="card col-12 md:col-12 lg:col-12">
            <DataTableGenerica muestraCabecera={false} //name="dfdfdf" name={props.name} level={props.level} codMenu={props.codMenu} label={props.label}
                selectedTipoGenerica={selectedTipoGenericaRef.current} />
        </div>);
    }

    if (tipoRecibo !== undefined && (tipoRecibo !== "I" && tipoRecibo !== "M")) {
        return (<></>);
    }

    else if (idEmpresa >= 0) {
        return (
            <>
                <div className="surface-card p-4 shadow-2 border-round w-full lg:w-12">
                    <div className="text-center mb-5">
                        <img src={urlFullLogoLogin} alt="hyper" height="150" className="mb-3" />
                        <div className="text-900 text-3xl font-medium mb-3">{"Portal Aldea - Recibos de Pago"}</div>
                        <span style={{ display: "none" }} className="text-600 font-medium line-height-3">{GetTextoEtiqueta("Label_NoTieneCuenta")}</span>
                        <button style={{ display: "none" }} className="p-link font-medium no-underline ml-2 text-blue-500 cursor-pointer">{GetTextoEtiqueta("Label_CrearCuentaHoy")}</button>
                    </div>

                    <div>
                        <label htmlFor="userName1" className="block text-900 font-medium mb-2">{"Num. Identificación"}</label>
                        <InputText id="userName" type="text" onChange={(e) => onInputChange(e, 'NUM_IDENTIFICACION')} className="w-full mb-3" value={dataConsulta.NUM_IDENTIFICACION} />
                        {mensajeError(intentoErrado)}
                        <Button id='btLogin' onClick={clickBuscar} label={"Buscar"} icon="pi pi-user" className="w-full" />
                    </div>
                    {TablaReciboInscripcion()}

                </div>
            </>
        )
    }
    else return (<></>);
}

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};
 
export default React.memo(BlocksLogin, comparisonFn);*/

export default BlocksInscripcion;
